import { Heart, MessageCircle, Bookmark, Share2, Music } from "lucide-react";

const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1618424599646-14f0a25990f1?w=400&h=700&fit=crop";

export const TikTokPreview = ({ content, media }) => {
  const displayMedia = media && media.length > 0 ? media[0] : null;
  const hasVideo = displayMedia?.type === "video";

  return (
    <div 
      className="preview-container relative bg-black rounded-xl overflow-hidden"
      style={{ aspectRatio: "9/16", maxHeight: "500px" }}
      data-testid="tiktok-preview"
    >
      {/* Background Media */}
      {hasVideo ? (
        <video 
          src={displayMedia.url} 
          className="absolute inset-0 w-full h-full object-cover"
          loop
          muted
          autoPlay
          playsInline
        />
      ) : (
        <img 
          src={displayMedia?.url || DEFAULT_IMAGE} 
          alt="TikTok preview"
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-14 p-4 text-white">
        {/* Username */}
        <div className="flex items-center gap-2 mb-2">
          <span className="font-bold text-[16px]">@mon_compte</span>
        </div>

        {/* Description */}
        <p className="text-[14px] leading-[1.4] line-clamp-3 mb-3">
          {content || "Décrivez votre vidéo..."}
        </p>

        {/* Music */}
        <div className="flex items-center gap-2">
          <Music className="w-4 h-4" />
          <div className="overflow-hidden">
            <p className="text-[14px] whitespace-nowrap animate-marquee">
              Son original - mon_compte
            </p>
          </div>
        </div>
      </div>

      {/* Right Sidebar */}
      <div className="absolute right-2 bottom-20 flex flex-col items-center gap-5">
        {/* Profile */}
        <div className="relative">
          <div className="w-12 h-12 rounded-full border-2 border-white overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1631387019069-2ff599943f9a?w=96&h=96&fit=crop&crop=face"
              alt="Profile"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-5 h-5 rounded-full bg-[#FE2C55] flex items-center justify-center">
            <span className="text-white text-[14px] font-bold">+</span>
          </div>
        </div>

        {/* Like */}
        <div className="flex flex-col items-center">
          <button className="w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center">
            <Heart className="w-6 h-6 text-white" />
          </button>
          <span className="text-white text-[12px] mt-1">12.5K</span>
        </div>

        {/* Comment */}
        <div className="flex flex-col items-center">
          <button className="w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center">
            <MessageCircle className="w-6 h-6 text-white" />
          </button>
          <span className="text-white text-[12px] mt-1">234</span>
        </div>

        {/* Bookmark */}
        <div className="flex flex-col items-center">
          <button className="w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center">
            <Bookmark className="w-6 h-6 text-white" />
          </button>
          <span className="text-white text-[12px] mt-1">89</span>
        </div>

        {/* Share */}
        <div className="flex flex-col items-center">
          <button className="w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center">
            <Share2 className="w-6 h-6 text-white" />
          </button>
          <span className="text-white text-[12px] mt-1">45</span>
        </div>

        {/* Spinning Record */}
        <div className="w-10 h-10 rounded-full bg-gradient-to-r from-gray-800 to-gray-900 border-2 border-gray-700 animate-spin-slow flex items-center justify-center">
          <div className="w-4 h-4 rounded-full overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1631387019069-2ff599943f9a?w=32&h=32&fit=crop&crop=face"
              alt="Album"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* No video warning */}
      {!hasVideo && (
        <div className="absolute top-4 left-4 right-4 p-3 rounded-lg bg-black/60 backdrop-blur-sm">
          <p className="text-white text-[13px] text-center">
            TikTok nécessite une vidéo pour publier
          </p>
        </div>
      )}
    </div>
  );
};

export default TikTokPreview;
